import { getSelectedSites } from '@vista-digital/occ-domain'
import { addDays } from 'date-fns'
import { makeAutoObservable } from 'mobx'

class TooltipStore {
    private storageKey = 'tooltip-date'
    public tooltipVisible = true

    public constructor() {
        makeAutoObservable(this)
    }

    public get isTooltipVisible() {
        return getSelectedSites().length <= 0 && this.isHidePeriodExpired() && this.tooltipVisible
    }

    public hideTooltip(expireAfterDays = 1) {
        const date = addDays(new Date(), expireAfterDays) // hard coding this to 1 for now, need to add this to CMS
        localStorage?.setItem(this.storageKey, date.toDateString())
        this.tooltipVisible = false
    }

    private isHidePeriodExpired() {
        const dateItem = localStorage?.getItem(this.storageKey)
        if (!dateItem) return true

        const now = new Date()
        const expiryData = new Date(dateItem)
        const isExpired = now >= expiryData

        if (isExpired) localStorage?.removeItem(this.storageKey)
        this.tooltipVisible = !isExpired
        return isExpired
    }
}

export const tooltipStore = new TooltipStore()
